import React from 'react';

const MatchCardSkeleton = () => {
  return (
    <div className="bg-gray-800 border border-gray-700 rounded-lg p-4 animate-pulse">
      {/* Header */}
      <div className="flex justify-between items-start mb-4">
        <div className="flex-1">
          <div className="h-6 bg-gray-700 rounded w-3/4 mb-2"></div>
          <div className="h-4 bg-gray-700 rounded w-1/2"></div>
        </div>
        <div className="h-6 w-16 bg-gray-700 rounded"></div>
      </div>

      {/* Details */}
      <div className="space-y-2 mb-4">
        <div className="h-4 bg-gray-700 rounded w-2/3"></div>
        <div className="h-4 bg-gray-700 rounded w-3/4"></div>
      </div>

      {/* Footer */}
      <div className="flex justify-between items-center">
        <div className="h-4 bg-gray-700 rounded w-1/3"></div>
        <div className="h-10 bg-gray-700 rounded w-24"></div>
      </div>
    </div>
  );
};

export default MatchCardSkeleton;
